"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class PublishedConnectionsApi extends runtime.BaseAPI {
    /**
     * Publishes an in-flight published connection
     * Publish published connection
     */
    publishedConnectionPersistenceServiceActivatePublishedConnectionRevisionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceActivatePublishedConnectionRevision.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceActivatePublishedConnectionRevision.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceActivatePublishedConnectionRevision.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.ActivatePublishedConnectionRevisionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}/activate`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1ActivatePublishedConnectionRevisionRequestToJSON(requestParameters.tableauPublishedconnectionV1ActivatePublishedConnectionRevisionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1PublishedConnectionFromJSON(jsonValue));
        });
    }
    /**
     * Publishes an in-flight published connection
     * Publish published connection
     */
    publishedConnectionPersistenceServiceActivatePublishedConnectionRevision(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceActivatePublishedConnectionRevisionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Check if a pconn is editable
     * Check permission on a published connection
     */
    publishedConnectionPersistenceServiceCheckEditPconnRevisionPermissionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceCheckEditPconnRevisionPermission.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceCheckEditPconnRevisionPermission.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/revisions/{revision_luid}/edit-permission`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1CheckEditPconnPermissionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Check if a pconn is editable
     * Check permission on a published connection
     */
    publishedConnectionPersistenceServiceCheckEditPconnRevisionPermission(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceCheckEditPconnRevisionPermissionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Creates a published connection revision on the logged in user\'s current site
     * Create a published connection revision
     */
    publishedConnectionPersistenceServiceCreatePublishedConnectionRevisionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceCreatePublishedConnectionRevision.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.CreatePublishedConnectionRevisionRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/-/revisions`.replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1CreatePublishedConnectionRevisionRequestToJSON(requestParameters.tableauPublishedconnectionV1CreatePublishedConnectionRevisionRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1PublishedConnectionFromJSON(jsonValue));
        });
    }
    /**
     * Creates a published connection revision on the logged in user\'s current site
     * Create a published connection revision
     */
    publishedConnectionPersistenceServiceCreatePublishedConnectionRevision(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceCreatePublishedConnectionRevisionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a published connection
     * Delete published connection
     */
    publishedConnectionPersistenceServiceDeletePublishedConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceDeletePublishedConnection.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceDeletePublishedConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}`.replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1DeletePublishedConnectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Deletes a published connection
     * Delete published connection
     */
    publishedConnectionPersistenceServiceDeletePublishedConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceDeletePublishedConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Deletes a published connection
     * Delete published connection
     */
    publishedConnectionPersistenceServiceDeletePublishedConnectionRevisionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceDeletePublishedConnectionRevision.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceDeletePublishedConnectionRevision.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceDeletePublishedConnectionRevision.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1DeletePublishedConnectionRevisionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Deletes a published connection
     * Delete published connection
     */
    publishedConnectionPersistenceServiceDeletePublishedConnectionRevision(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceDeletePublishedConnectionRevisionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves a published connection
     * Retrieve published connection
     */
    publishedConnectionPersistenceServiceGetPublishedConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceGetPublishedConnection.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceGetPublishedConnection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}`.replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1PublishedConnectionFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves a published connection
     * Retrieve published connection
     */
    publishedConnectionPersistenceServiceGetPublishedConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceGetPublishedConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves the in-flight revision luid for a given published connection if it exists
     * Retrieve the in-flight revision luid for a given published connection if it exists
     */
    publishedConnectionPersistenceServiceGetPublishedConnectionInflightRevisionLuidRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceGetPublishedConnectionInflightRevisionLuid.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/published-connections/{pconn_luid}/inflight_revision_luid/`.replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1GetPublishedConnectionInflightRevisionLuidResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves the in-flight revision luid for a given published connection if it exists
     * Retrieve the in-flight revision luid for a given published connection if it exists
     */
    publishedConnectionPersistenceServiceGetPublishedConnectionInflightRevisionLuid(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceGetPublishedConnectionInflightRevisionLuidRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves a published connection revision
     * Retrieve published connection revision
     */
    publishedConnectionPersistenceServiceGetPublishedConnectionRevisionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceGetPublishedConnectionRevision.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceGetPublishedConnectionRevision.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceGetPublishedConnectionRevision.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1PublishedConnectionFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves a published connection revision
     * Retrieve published connection revision
     */
    publishedConnectionPersistenceServiceGetPublishedConnectionRevision(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceGetPublishedConnectionRevisionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all of the Columns within a table of this published connection with synced results
     * List Columns
     */
    publishedConnectionPersistenceServiceListColumnSyncDetailsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumnSyncDetails.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumnSyncDetails.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumnSyncDetails.');
            }
            if (requestParameters.tableLuid === null || requestParameters.tableLuid === undefined) {
                throw new runtime.RequiredError('tableLuid', 'Required parameter requestParameters.tableLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumnSyncDetails.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}/tables/{table_luid}/syncedcolumns`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))).replace(`{${"table_luid"}}`, encodeURIComponent(String(requestParameters.tableLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1ListColumnSyncDetailsResponseFromJSON(jsonValue));
        });
    }
    /**
     * List all of the Columns within a table of this published connection with synced results
     * List Columns
     */
    publishedConnectionPersistenceServiceListColumnSyncDetails(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceListColumnSyncDetailsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all of the Columns within a table of this published connection
     * List Columns
     */
    publishedConnectionPersistenceServiceListColumnsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumns.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumns.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumns.');
            }
            if (requestParameters.tableLuid === null || requestParameters.tableLuid === undefined) {
                throw new runtime.RequiredError('tableLuid', 'Required parameter requestParameters.tableLuid was null or undefined when calling publishedConnectionPersistenceServiceListColumns.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}/tables/{table_luid}/listcolumns`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))).replace(`{${"table_luid"}}`, encodeURIComponent(String(requestParameters.tableLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1ListColumnsResponseFromJSON(jsonValue));
        });
    }
    /**
     * List all of the Columns within a table of this published connection
     * List Columns
     */
    publishedConnectionPersistenceServiceListColumns(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceListColumnsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Lists all the published connections the the current user has access to on the current site.
     * List published connections
     */
    publishedConnectionPersistenceServiceListPublishedConnectionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceListPublishedConnections.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections`.replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1ListPublishedConnectionsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Lists all the published connections the the current user has access to on the current site.
     * List published connections
     */
    publishedConnectionPersistenceServiceListPublishedConnections(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceListPublishedConnectionsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Sync metadata for given pconn table
     * Sync metadata for given pconn table
     */
    publishedConnectionPersistenceServiceSyncMetadataRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceSyncMetadata.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceSyncMetadata.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceSyncMetadata.');
            }
            if (requestParameters.tableLuid === null || requestParameters.tableLuid === undefined) {
                throw new runtime.RequiredError('tableLuid', 'Required parameter requestParameters.tableLuid was null or undefined when calling publishedConnectionPersistenceServiceSyncMetadata.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.SyncMetadataRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}/tables/{table_luid}/sync`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))).replace(`{${"table_luid"}}`, encodeURIComponent(String(requestParameters.tableLuid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1SyncMetadataRequestToJSON(requestParameters.tableauPublishedconnectionV1SyncMetadataRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1SyncMetadataResponseFromJSON(jsonValue));
        });
    }
    /**
     * Sync metadata for given pconn table
     * Sync metadata for given pconn table
     */
    publishedConnectionPersistenceServiceSyncMetadata(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceSyncMetadataRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Updates the columns of a table in a published connection
     * Update columns
     */
    publishedConnectionPersistenceServiceUpdateColumnsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceUpdateColumns.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionPersistenceServiceUpdateColumns.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceUpdateColumns.');
            }
            if (requestParameters.tableLuid === null || requestParameters.tableLuid === undefined) {
                throw new runtime.RequiredError('tableLuid', 'Required parameter requestParameters.tableLuid was null or undefined when calling publishedConnectionPersistenceServiceUpdateColumns.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.UpdateColumnsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{pconn_luid}/revisions/{revision_luid}/tables/{table_luid}/updatecolumns`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))).replace(`{${"table_luid"}}`, encodeURIComponent(String(requestParameters.tableLuid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1UpdateColumnsRequestToJSON(requestParameters.tableauPublishedconnectionV1UpdateColumnsRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Updates the columns of a table in a published connection
     * Update columns
     */
    publishedConnectionPersistenceServiceUpdateColumns(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.publishedConnectionPersistenceServiceUpdateColumnsRaw(requestParameters);
        });
    }
    /**
     * Updates the specified attributes of a published connection revision
     * Update published connection revision
     */
    publishedConnectionPersistenceServiceUpdatePublishedConnectionRevisionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionPersistenceServiceUpdatePublishedConnectionRevision.');
            }
            if (requestParameters.parentSiteLuid === null || requestParameters.parentSiteLuid === undefined) {
                throw new runtime.RequiredError('parentSiteLuid', 'Required parameter requestParameters.parentSiteLuid was null or undefined when calling publishedConnectionPersistenceServiceUpdatePublishedConnectionRevision.');
            }
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling publishedConnectionPersistenceServiceUpdatePublishedConnectionRevision.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.PublishedConnection+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/data-composition/sites/{parent_site_luid}/published-connections/{luid}/revisions/{revision_luid}`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"parent_site_luid"}}`, encodeURIComponent(String(requestParameters.parentSiteLuid))).replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1PublishedConnectionToJSON(requestParameters.tableauPublishedconnectionV1PublishedConnection),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1PublishedConnectionFromJSON(jsonValue));
        });
    }
    /**
     * Updates the specified attributes of a published connection revision
     * Update published connection revision
     */
    publishedConnectionPersistenceServiceUpdatePublishedConnectionRevision(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionPersistenceServiceUpdatePublishedConnectionRevisionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Cancels extract creation for an in-flight revision.
     * Cancels extract creation for an in-flight revision.
     */
    publishedConnectionServiceCancelExtractCreationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionServiceCancelExtractCreation.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionServiceCancelExtractCreation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.CancelExtractCreationRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/published-connections/{pconn_luid}/revision/{revision_luid}/cancel-extract-creation`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1CancelExtractCreationRequestToJSON(requestParameters.tableauPublishedconnectionV1CancelExtractCreationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1CancelExtractCreationResponseFromJSON(jsonValue));
        });
    }
    /**
     * Cancels extract creation for an in-flight revision.
     * Cancels extract creation for an in-flight revision.
     */
    publishedConnectionServiceCancelExtractCreation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionServiceCancelExtractCreationRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Initiates a change to the querying mode. The effect of the change on querying happens eventually-- when switching to extract-- if an extract needs to be created first.
     * Initiates a change to the querying mode.
     */
    publishedConnectionServiceChangeQueryModeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling publishedConnectionServiceChangeQueryMode.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.ChangeQueryModeRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/published-connections/{luid}/query-mode-change`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1ChangeQueryModeRequestToJSON(requestParameters.tableauPublishedconnectionV1ChangeQueryModeRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Initiates a change to the querying mode. The effect of the change on querying happens eventually-- when switching to extract-- if an extract needs to be created first.
     * Initiates a change to the querying mode.
     */
    publishedConnectionServiceChangeQueryMode(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.publishedConnectionServiceChangeQueryModeRaw(requestParameters);
        });
    }
    /**
     * Get extract status of the inflight revision for the published connection including all its tables.
     * Get extract status of the published connection inflight revision.
     */
    publishedConnectionServiceGetPublishedConnectionInflightRevisionExtractStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionServiceGetPublishedConnectionInflightRevisionExtractStatus.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionServiceGetPublishedConnectionInflightRevisionExtractStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/published-connections/{pconn_luid}/revision/{revision_luid}/extract-status`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1GetPublishedConnectionInflightRevisionExtractStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get extract status of the inflight revision for the published connection including all its tables.
     * Get extract status of the published connection inflight revision.
     */
    publishedConnectionServiceGetPublishedConnectionInflightRevisionExtractStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionServiceGetPublishedConnectionInflightRevisionExtractStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Start an extract refresh for the published connection. The state of the extract may be queried with GetPublishedConnection.
     * Start an extract refresh for the published connection.
     */
    publishedConnectionServiceRefreshPublishedConnectionExtractRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.luid === null || requestParameters.luid === undefined) {
                throw new runtime.RequiredError('luid', 'Required parameter requestParameters.luid was null or undefined when calling publishedConnectionServiceRefreshPublishedConnectionExtract.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.RefreshPublishedConnectionExtractRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/published-connections/{luid}/extract-refresh`.replace(`{${"luid"}}`, encodeURIComponent(String(requestParameters.luid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1RefreshPublishedConnectionExtractRequestToJSON(requestParameters.tableauPublishedconnectionV1RefreshPublishedConnectionExtractRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauPublishedconnectionV1RefreshPublishedConnectionExtractResponseFromJSON(jsonValue));
        });
    }
    /**
     * Start an extract refresh for the published connection. The state of the extract may be queried with GetPublishedConnection.
     * Start an extract refresh for the published connection.
     */
    publishedConnectionServiceRefreshPublishedConnectionExtract(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.publishedConnectionServiceRefreshPublishedConnectionExtractRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Initiates extract creation for an in-flight revision.
     * Initiates extract creation for an in-flight revision.
     */
    publishedConnectionServiceStartExtractCreationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.revisionLuid === null || requestParameters.revisionLuid === undefined) {
                throw new runtime.RequiredError('revisionLuid', 'Required parameter requestParameters.revisionLuid was null or undefined when calling publishedConnectionServiceStartExtractCreation.');
            }
            if (requestParameters.pconnLuid === null || requestParameters.pconnLuid === undefined) {
                throw new runtime.RequiredError('pconnLuid', 'Required parameter requestParameters.pconnLuid was null or undefined when calling publishedConnectionServiceStartExtractCreation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.publishedconnection.v1.StartExtractCreationRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/published-connections/{pconn_luid}/revision/{revision_luid}/start-extract-creation`.replace(`{${"revision_luid"}}`, encodeURIComponent(String(requestParameters.revisionLuid))).replace(`{${"pconn_luid"}}`, encodeURIComponent(String(requestParameters.pconnLuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauPublishedconnectionV1StartExtractCreationRequestToJSON(requestParameters.tableauPublishedconnectionV1StartExtractCreationRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Initiates extract creation for an in-flight revision.
     * Initiates extract creation for an in-flight revision.
     */
    publishedConnectionServiceStartExtractCreation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.publishedConnectionServiceStartExtractCreationRaw(requestParameters);
        });
    }
}
exports.PublishedConnectionsApi = PublishedConnectionsApi;
